import React from "react";
import { Box, Typography } from "@mui/material";
import { InfoTooltip } from "components/info-tooltip";
import { CALCULATED_FALLBACK } from "components/metric-card";
import { ReadOnlyStatProps } from "./types";

export const ReadOnlyStat: React.FC<ReadOnlyStatProps> = ({
  label,
  sublabel,
  value,
  tooltip,
}) => (
  <Box
    sx={{
      flex: 1,
      minWidth: 160,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      backgroundColor: "white",
      borderRadius: "8px",
      border: "1px solid #E2E8F0",
      px: 2.5,
      py: 2,
    }}
  >
    <Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Typography
          sx={{ fontSize: "0.8125rem", fontWeight: 600, color: "#475569" }}
        >
          {label}
        </Typography>
        {tooltip && (
          <InfoTooltip tooltip={tooltip} colors={CALCULATED_FALLBACK} />
        )}
      </Box>
      {sublabel && (
        <Typography sx={{ fontSize: "0.75rem", color: "#94A3B8", mt: 0.25 }}>
          {sublabel}
        </Typography>
      )}
    </Box>
    <Typography sx={{ fontSize: "1.5rem", fontWeight: 800, color: "#1A4252" }}>
      {value}
    </Typography>
  </Box>
);
